<template>
  <div>
    <el-select :filterable="true" :remote="true" :remote-method="handleRemote" :value="value" value-key="id" :size="size" placeholder="请选择" @input="change($event)" :clearable="true">
      <el-option v-for="item in optionsReader()" :key="item.id" :label="item.name" :value="item" />
    </el-select>
    <el-button v-if="config && config.update" @click="handleUpdate" >{{ $t('table.update') }}</el-button>
  </div>
</template>

<script>

import { fetchList } from '../api/client_mode'
import {debounce} from '../../utils'
export default {
  data () {
    return {
      emptyValue: { id: 0 },
      options: [],
      configOptions: null,
      optionsReader: () => { if (this.config) { return this.configOptions } return this.options },
      serach: [],
      res: [],
      isSerach: false,
      formData: {
        pageIndex: 1,
        pageSize: 10,
        serachPageIndex: 1,
        serachPageSize: 20
      },
      dropDownValue: ''
    }
  },
  created () {
    fetchList({limit: 0}).then((res) => {
      this.options = res.data.map((item) => { item.id = parseInt(item.id); return item })
      this.configOptions = this.config ? this.options.filter((item) => { return item.id === parseInt(this.config.selected) }) : this.options
    })
  },
  mounted () {
  },
  props: ['value', 'size', 'config', 'showAllTip', 'showAllTipLabel'],
  methods: {
    handleRemote (data) {
      debounce(() => {
        this.dropDownValue = data
        this.options = []
        this.handleUpdate(false)
      }, 2000, true)()
    },
    change: function (val) {
      this.$emit('input', val)
    },
    handleUpdate (loadMore = false) {
      let q = []
      let query = {}
      if (this.dropDownValue) {
        if (loadMore) {
          this.formData.serachPageIndex++
          this.serach = this.options
        }
        this.isSerach = true
        query.limit = this.formData.serachPageSize
        query.page = this.formData.serachPageIndex
        q.push(['like', 'name', '%' + this.dropDownValue + '%'].join(','))
      } else {
        if (loadMore) {
          this.formData.pageIndex++
          this.res = this.options
        }
        this.isSerach = false
        query.limit = this.formData.pageSize
        query.page = this.formData.pageIndex
      }
      query.q = q.join('&')
      fetchList(query).then((res) => {
        const _res = res.data.map((item) => { item.user_id = parseInt(item.user_id); return item })
        if (this.isSerach) {
          this.options = [...this.serach, ..._res]
        } else {
          this.options = [...this.res, ..._res]
        }
      })
    },
    init (open) {
      this.dropDownValue = ''
    },
    loadMore () {
      this.handleUpdate(true)
    }
  },
  watch: {
    config: function (val, old) {
      this.configOptions = val ? this.options.filter((item) => { return item.id === parseInt(val.selected) }) : this.options
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/card/components/ClientModeSelect.vue